// Industry Reviewers — critics and publications that assess wholesale drops

export const REVIEWERS = [
  {
    id: 'super-terp-mag',
    name: 'Super Terp Mag',
    handle: '@SuperTerpMag',
    emoji: '🌿',
    bias: 'terpene',
    corporateBias: -15,
    description: 'The premier terpene enthusiast publication.',
    minStage: 1,
    reputationWeight: 0.8,   // how much this review shifts rep
    quotes: {
      excellent: ['Nose was transcendent. Buy everything this op produces.', 'Profile complexity we haven\'t seen in years.', 'Terpenes singing. This is what the culture is for.'],
      good:      ['Solid aromatics. A grower who knows what they\'re doing.', 'Good expression — not groundbreaking but honest work.', 'Pleasant, consistent nose. More flower pls.'],
      average:   ['Flat profile. Fix your VPD and try again.', 'We expected more from this strain. Muted output.', 'Curing could save this. Borderline.'],
      poor:      ['Smells like hay and missed potential.', 'This batch should have stayed in the room longer.', 'Hard pass. Terpenes never developed.'],
    },
  },
  {
    id: 'government-kush',
    name: 'GovernmentKush.mu',
    handle: '@GovKush',
    emoji: '🏛️',
    bias: 'compliance',
    corporateBias: -12,
    description: 'Regulatory watchdog scoring track record as much as flower.',
    minStage: 1,
    reputationWeight: 1.2,   // compliance issues hit harder here
    quotes: {
      excellent: ['Clean operation. Consumer confidence warranted.', 'Fully licensed, quality verified. This is how it\'s done.', 'Regulatory exemplar. Other cultivators take note.'],
      good:      ['Licensed and consistent. No flags from our team.', 'Compliant and capable. Watching with interest.', 'Clean record. Solid batch.'],
      average:   ['Product is acceptable. Compliance history gives us pause.', 'Flower is mediocre. No violations on record, but barely.', 'Room for improvement on both quality and conduct.'],
      poor:      ['We have concerns. Consumers deserve better transparency.', 'Track record is a problem. Quality doesn\'t help.', 'Do not recommend. Compliance issues remain unresolved.'],
    },
  },
  {
    id: 'dank-daily',
    name: 'Dank Daily',
    handle: '@DankDaily',
    emoji: '💨',
    bias: 'potency',
    corporateBias: -8,
    description: 'If it doesn\'t knock you sideways, they\'re not interested.',
    minStage: 1,
    reputationWeight: 0.7,
    quotes: {
      excellent: ['Hits like a freight train. Certified heater.', 'Maximum THC, maximum respect. A classic.', 'Face-melting. The community will love this drop.'],
      good:      ['Solid punch. Worth your Friday night.', 'Good potency, we\'d buy a zip.', 'Above average effects. Recommend for experienced users.'],
      average:   ['Moderate at best. Not what the strain is capable of.', 'Effects are there but so is disappointment.', 'Mid-tier flower for mid-tier occasions.'],
      poor:      ['Weak. Fix your flower or change your strain.', 'Barely felt it. What happened in that room?', 'Not Dank Daily approved. Come back stronger.'],
    },
  },
  {
    id: 'budbuyers-guide',
    name: 'Bud Buyer\'s Guide',
    handle: '@BudBuyersGuide',
    emoji: '📖',
    bias: 'value',
    corporateBias: 3,
    description: 'Consumer advocacy — quality relative to what you\'re paying.',
    minStage: 1,
    reputationWeight: 0.9,
    quotes: {
      excellent: ['Exceptional value. Top shelf without the premium markup.', 'Consumers win with this drop. Highly recommend.', 'Punches well above its price point. Stock up.'],
      good:      ['Solid flower, fair price. A reliable choice.', 'Good value. Nothing to complain about.', 'Consistent quality. Consumers can trust this operation.'],
      average:   ['Acceptable but priced correctly for what it is.', 'Not sure the price is justified but it\'ll move.', 'Middle of the road. Fine for what it is.'],
      poor:      ['Overpriced for what\'s delivered. Consumers beware.', 'Quality doesn\'t justify the ask.', 'We\'ve seen better from this strain at lower prices.'],
    },
  },
  {
    id: 'the-dispensary-review',
    name: 'The Dispensary Review',
    handle: '@DispensaryReview',
    emoji: '🏥',
    bias: 'medical',
    corporateBias: 8,
    description: 'Medical-grade standards for therapeutic consumers.',
    minStage: 2,
    reputationWeight: 1.1,
    quotes: {
      excellent: ['Therapeutic potential is real. Patients will benefit.', 'Clean, consistent, and effective. Medical gold standard.', 'Exceptional product for symptom management applications.'],
      good:      ['Meets medical expectations. Reliable sourcing.', 'Quality is there for medical consumers. Consistent.', 'Suitable for therapeutic use. No concerns.'],
      average:   ['Barely meets the bar. Medical consumers need better consistency.', 'Acceptable but patients deserve more attention to detail.', 'Functional but underwhelming for medical use cases.'],
      poor:      ['We cannot recommend this for medical consumers.', 'Inconsistency is a disqualifier in medical contexts.', 'Quality control failure. Not suitable for patient use.'],
    },
  },
  {
    id: 'high-times-west',
    name: 'High Times West',
    handle: '@HTWest',
    emoji: '⭐',
    bias: 'balanced',
    corporateBias: 5,
    description: 'The most prestigious voice in the industry. Getting reviewed here matters.',
    minStage: 2,
    reputationWeight: 1.5,   // biggest reputation impact
    quotes: {
      excellent: ['This is what excellence looks like. A generational drop.', 'Industry benchmark. Other cultivators will study this batch.', 'Five stars. Rare and warranted. Absolutely exceptional.'],
      good:      ['Strong effort. This grower knows their craft.', 'Quality that stands out in a crowded market.', 'Well-grown, well-cured, well-presented. Solid.'],
      average:   ['Competent but forgettable. Grow harder.', 'Nothing offensive, nothing memorable. More care next cycle.', 'Potential is there. Execution fell short.'],
      poor:      ['Disappointing. This strain deserved better stewardship.', 'Below the standard we expect. Recalibrate your operation.', 'We expected more. The community expects more.'],
    },
  },
];

// Get reviewer by id
export function getReviewer(id) {
  return REVIEWERS.find(r => r.id === id) || null;
}

// Get reviewers available at the given stage
export function getAvailableReviewers(stage) {
  return REVIEWERS.filter(r => r.minStage <= stage);
}

// Pick a random reviewer quote based on score
export function getReviewQuote(reviewer, score) {
  const bucket = score >= 80 ? 'excellent' : score >= 60 ? 'good' : score >= 40 ? 'average' : 'poor';
  const pool = reviewer.quotes[bucket];
  return pool[Math.floor(Math.random() * pool.length)];
}
